<template>
    <div :class="baseContainerClasses" @mouseenter="onEnter" @mouseleave="onLeave" @click.prevent="onClick">
        <slot :hover="hover" :color="currentColor">

        </slot>
    </div>
</template>

<script>
import BaseContainer from './BaseContainer';

export default {
    name    : 'lego-box',
    extends : BaseContainer,
    props   : {
        link : { type : String, default : '' }
    },
    computed : {
        additionalClasses () {
            if (this.link) {
                return 'mu-p';
            }
            return '';
        }
    },
    methods : {
        onClick () {
            if (this.link) {
                this.$router.push(this.link);
            }
        },
        onEnter () {
            this.hover = true;
            this.$emit('mouse-enter');
        },
        onLeave () {
            this.hover = false;
            this.$emit('mouse-leave');
        }
    }
};
</script>

<style scoped>

</style>
